import { BasicParameter } from '../../common/parameters/extensions'

export interface IIMRErrorsSummary {
    setSummaryOptions(summaryOptions: SummaryOptions): void
}

export interface ErrorsSummaryResult {
    key: number
    isVisible: boolean
    description: string
    status: string
}

export interface SummaryOptions {
    parameters: BasicParameter[]
    title: string
    duration: number
    summaryResult: ErrorsSummaryResult[]
    errorMarker: string
}

export class ErrorRowItem {
    occurrences: number
    name: string
    status: string
    id: number
    mainGridKeys: number[]
}

export type IMRErrorsSummaryOptions = {
    onInitialized(errorsSummary: IIMRErrorsSummary): void
    onSelectErrorRows(keys: number[]): void
}